/** @typedef {import('@/types/api').PosRedeemablePackage} PosRedeemablePackage */

import { isFlexibleComboPackage } from '@/lib/pos/posFlexibleCombo'

/**
 * @param {PosRedeemablePackage[]} packages
 * @param {string} query
 */
export function filterRedeemablePackages(packages, query) {
  const needle = query.trim().toLowerCase()
  if (!needle) return packages

  return packages.filter((pkg) => {
    const menuNames = isFlexibleComboPackage(pkg)
      ? pkg.flexible_combo.menu.map((item) => item.service_name)
      : []

    const haystack = [
      pkg.package_name,
      pkg.package_type,
      ...pkg.services.map((service) => `${service.service_name} ${service.remaining_label}`),
      ...menuNames,
    ]
      .join(' ')
      .toLowerCase()

    return haystack.includes(needle)
  })
}

/**
 * @param {PosRedeemablePackage | null | undefined} pkg
 * @param {number | null | undefined} serviceId
 */
export function findRedeemableService(pkg, serviceId) {
  if (!pkg || !serviceId) return null
  return pkg.services.find((service) => service.service_id === serviceId) ?? null
}

/**
 * @param {import('@/types/api').SaleLine} line
 */
export function isPackageCoveredLine(line) {
  return Boolean(line.customer_package_id || line.customer_package?.id)
}
